import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useEffect, useState } from 'react';
import { fetchTasks } from '@/entities/task';
import { completeTaskAction, startTaskAction, } from '@/features/complete-task';
import { ApiError } from '@/shared/api';
import { uiCopy, taskStatusLabel } from '@/shared/copy';
import { Alert, AlertDescription, AlertTitle, Button, Sheet, Skeleton, } from '@/shared/ui';
export function TaskList() {
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [selected, setSelected] = useState(null);
    const [busy, setBusy] = useState(false);
    const load = useCallback(async () => {
        setLoading(true);
        setError(null);
        try {
            const data = await fetchTasks('OPEN');
            setItems(data.items);
        }
        catch (err) {
            setError(err instanceof ApiError ? err.message : uiCopy.loadFailed);
        }
        finally {
            setLoading(false);
        }
    }, []);
    useEffect(() => {
        void load();
    }, [load]);
    if (loading)
        return _jsx(Skeleton, { className: "h-64 w-full" });
    return (_jsxs("div", { className: "space-y-4", children: [error ? (_jsxs(Alert, { variant: "destructive", children: [_jsx(AlertTitle, { children: uiCopy.errorTitle }), _jsx(AlertDescription, { children: error })] })) : null, items.length === 0 ? (_jsxs(Alert, { children: [_jsx(AlertTitle, { children: "\u041E\u0442\u043A\u0440\u044B\u0442\u044B\u0445 \u0437\u0430\u0434\u0430\u0447 \u043D\u0435\u0442" }), _jsx(AlertDescription, { children: "\u041C\u043E\u0436\u043D\u043E \u0437\u0430\u043D\u044F\u0442\u044C\u0441\u044F \u043E\u0447\u0435\u0440\u0435\u0434\u044F\u043C\u0438 \u0438\u043B\u0438 \u043F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0432\u043E\u0440\u043E\u043D\u043A\u0443." })] })) : null, _jsx("ul", { className: "divide-y divide-border rounded-md border border-border", children: items.map((item) => (_jsx("li", { children: _jsxs("button", { type: "button", className: "flex w-full justify-between px-4 py-3 text-left hover:bg-muted/40", onClick: () => setSelected(item), children: [_jsx("span", { className: "font-medium", children: item.title }), _jsx("span", { className: "text-sm text-muted-foreground", children: taskStatusLabel(item.status) })] }) }, item.taskId))) }), _jsx(Sheet, { open: selected !== null, onClose: () => setSelected(null), title: selected?.title ?? 'Задача', children: selected ? (_jsxs("div", { className: "space-y-3 text-sm", children: [_jsxs("p", { children: ["\u0421\u0442\u0430\u0442\u0443\u0441: ", taskStatusLabel(selected.status)] }), selected.agentDisplayName ? (_jsxs("p", { children: ["\u0410\u0433\u0435\u043D\u0442: ", selected.agentDisplayName] })) : null, selected.description ? _jsx("p", { children: selected.description }) : null, _jsxs("div", { className: "flex flex-col gap-2", children: [selected.status === 'OPEN' ? (_jsx(Button, { type: "button", disabled: busy, onClick: () => {
                                        void (async () => {
                                            setBusy(true);
                                            try {
                                                await startTaskAction(selected.taskId, selected.version);
                                                setSelected(null);
                                                await load();
                                            }
                                            catch (err) {
                                                setError(err instanceof ApiError ? err.message : uiCopy.actionFailed);
                                            }
                                            finally {
                                                setBusy(false);
                                            }
                                        })();
                                    }, children: "\u041D\u0430\u0447\u0430\u0442\u044C \u0440\u0430\u0431\u043E\u0442\u0443" })) : null, _jsx(Button, { type: "button", variant: "secondary", disabled: busy, onClick: () => {
                                        void (async () => {
                                            setBusy(true);
                                            try {
                                                await completeTaskAction(selected.taskId, selected.version);
                                                setSelected(null);
                                                await load();
                                            }
                                            catch (err) {
                                                setError(err instanceof ApiError ? err.message : uiCopy.actionFailed);
                                            }
                                            finally {
                                                setBusy(false);
                                            }
                                        })();
                                    }, children: "\u0413\u043E\u0442\u043E\u0432\u043E" })] })] })) : null })] }));
}
